import { Table } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import ExpensesTableBody from './ExpensesTableBody';
import type { IncomeExpenseRow } from '../model';

interface ExpensesTableProps {
    rows: IncomeExpenseRow[];
    readOnly: boolean;
    deletingId: number | null;
    onDelete: (row: IncomeExpenseRow) => void;
}

const ExpensesTable = ({ rows, readOnly, deletingId, onDelete }: ExpensesTableProps) => {
    const { t } = useTranslation(['Objects']);

    return (
        <div className="crm-table-wrap">
            <Table className="ExpendTeamExpensesTable table-hover mb-0">
                <thead>
                    <tr className="bg-light">
                        <td className="head-username">{t('expendTeamExpenses.cols.user')}</td>
                        <td className="head-date">{t('expendTeamExpenses.cols.date')}</td>
                        <td className="head-amount">{t('expendTeamExpenses.cols.amount')}</td>
                        <td className="head-note">{t('expendTeamExpenses.cols.comment')}</td>
                        <td className="head-action" />
                    </tr>
                </thead>
                <ExpensesTableBody
                    rows={rows}
                    readOnly={readOnly}
                    deletingId={deletingId}
                    onDelete={onDelete}
                />
            </Table>
        </div>
    );
};

export default ExpensesTable;
